import SearchState from './search'
import HorseState from './horse'
import UserState from './user'
import AuthState from './auth'
import SliderState from './slider'
import PageState from './page'
import FeatureState from './feature'
import NotificationState from './notification'
import ContactState from './contact'
import DonateState from './donate'
import NewHorseState from './newHorse'
import TranslateState from './translate'
import BreederState from './breeder'
import OwnerState from './owner'
import MainState from './main'
import HorseshoeState from './horseshoe'
import AdState from './ad'
import StoreState from './store'
import ProductState from './product'

export default {
  search: SearchState,
  horse: HorseState,
  user: UserState,
  auth: AuthState,
  slider: SliderState,
  page: PageState,
  notification: NotificationState,
  feature: FeatureState,
  contact: ContactState,
  donate: DonateState,
  newHorse: NewHorseState,
  translate: TranslateState,
  main: MainState,
  breeder: BreederState,
  store: StoreState,
  owner: OwnerState,
  ad: AdState,
  horseshoe: HorseshoeState,
  product: ProductState
}



// WEBPACK FOOTER //
// ./src/states/index.js